<template>
  <div>
    <el-form :label-position="labelPosition" label-width="0px" :model="formLabelAlign">
      <el-form-item label="" style="text-align: left; margin-left: 40px; margin-bottom: 0px;margin-top: 0px;">
        <span><i style="color: #f56c6c">* </i>设置判断条件</span>
      </el-form-item>
      <el-form-item label="" v-for="(item, index) in condition" :key="index">
        <el-button class="el-icon-error" @click="deleteItemAction(index)" style="width: 20px; height: 20px; line-height: 20px; padding: 0px;"></el-button>
        <el-cascader
          v-model="item.selectedOptions"
          :options="activityOptions"
          @change="activitySelectChange(item)"
          style="margin-bottom: 10px; width: 340px; margin-left: 0px;">
        </el-cascader>
        <el-select filterable @change="handleChange" v-model="item.subSelectedOptions" v-show="item.selectShow" style="width: 340px;margin-left: 24px">
          <el-option
            v-for="i in item.changeOptions"
            :key="i.value"
            :label="i.label"
            :value="i.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" size="small" @click="newConditionAction">新增一组条件</el-button>
      </el-form-item>
      <el-form-item label="" style="text-align: left; margin-left: 40px; margin-bottom: 0px;margin-top: 0px;">
        <span>指定时间内判断</span>
      </el-form-item>
      <el-form-item style="text-align: left;">
        <el-input-number v-model="day" controls-position="right" @change="handleChange" :min="1" :max="10" style="width: 80px; margin-left: 40px; margin-right: 3px;"></el-input-number>天
        <el-input-number v-model="hours" controls-position="right" @change="handleChange" :min="1" :max="10" style="width: 80px; margin-left: 10px; margin-right: 3px;"></el-input-number>小时
        <el-input-number v-model="mins" controls-position="right" @change="handleChange" :min="1" :max="10" style="width: 80px;margin-left: 10px; margin-right: 3px;"></el-input-number>分钟
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getGroupList, getWechatPublicListForNode, getWePagesListForNode, getMessageList, getEventList, getBigWheelList } from '@/api/customer.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      selectShow: true,
      activityOptions: [],
      day: this.contents.day,
      hours: this.contents.hours,
      nodeType: this.contents.nodeType,
      mins: this.contents.mins,
      addGroupName: '加入群组',
      addGroupOptions: [],
      value: '',
      search: {
        status: 2
      },
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      },
      condition: this.contents.content
    }
  },
  computed: {
  },
  methods: {
    activitySelectChange(item) {
      console.log('item', item)
      item.changeOptions = []
      let value = item.selectedOptions
      if (value[0] === 'wechat') {
        item.selectShow = true
        this.getWechatPublicList(item)
      } else if (value[0] === 'wepage') {
        item.selectShow = true
        this.getWePagesList(item)
      } else if (value[0] === 'sms') {
        item.selectShow = true
        this.getMessageTemplateList(item)
      } else if (value[0] === 'order') {
        item.selectShow = false
      } else if (value[0] === 'member' || value[0] === 'user_defined_event') {
        item.selectShow = false
      } else if (value[0] === 'Interactive_activities') {
        item.selectShow = true
        this.loadBigWheelList(item)
      }
      this.handleChange()
    },
    // 请求微信公众号列表
    getWechatPublicList(items) {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          items.changeOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
      })
    },
    // 请求大转盘列表
    loadBigWheelList(items) {
      getBigWheelList().then((res) => {
        if (res.data.code === 0) {
          for (let item of res.data.data.list) {
            items.changeOptions.push({
              label: item.name,
              value: item.id
            })
          }
        }
      })
    },
    // 请求微页面列表
    getWePagesList(items) {
      getWePagesListForNode().then((res) => {
        for (let item of res.data.data.list) {
          items.changeOptions.push({
            label: item.name,
            value: item.id
          })
        }
      })
    },
    // 短信消息模板列表
    getMessageTemplateList(items) {
      getMessageList(1, this.search).then((res) => {
        console.log('getWePagesListForNode', res)
        for (let item of res.data.data.list) {
          items.changeOptions.push({
            label: item.sms_name,
            value: item.id
          })
        }
      })
    },
    // 营销活动 事件列表
    getActivityList() {
      getEventList().then((res) => {
        for (let list of res.data.data.list) {
          for (let one of list.children) {
            one.label = one.name
            one.value = one.identity
          }
        }
        for (let ite of res.data.data.list) {
          if (ite.identity === 'wepage') {
            for (let i in ite.children) {
              if (ite.children[i].identity === 'wepage_forward_to_wechat') {
                ite.children.splice(i, 1)
              }
              if (ite.children[i].identity === 'wepage_forward_to_we_friend') {
                ite.children.splice(i, 1)
              }
            }
          }
        }
        for (let item of res.data.data.list) {
          if (item.identity === 'member') {
            continue
          }
          this.activityOptions.push({
            value: item.identity,
            label: item.name,
            children: item.children
          })
        }
      })
    },
    loadGroupList() {
      getGroupList().then((res) => {
        this.addGroupOptions = res.data.data.list
      })
    },
    newConditionAction() {
      this.condition.push({
        conditionIndex: this.condition.length + 1,
        selectShow: true,
        selectedOptions: [],
        subSelectedOptions: '',
        changeOptions: []
      })
      console.log('item.selectedOptions', this.condition)
    },
    deleteItemAction (index) {
      if (this.condition.length > 1) {
        this.condition.splice(index, 1)
      }
    },
    handleChange() {
      let sendArr = []
      for (let item of this.condition) {
        sendArr.push({
          selectedOptions: item.selectedOptions,
          subSelectedOptions: item.subSelectedOptions
        })
      }
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'eventJudgeNode'
      choose.content = this.condition
      choose.day = this.day
      choose.hours = this.hours
      choose.mins = this.mins
      choose.id = this.contents.id
      this.$emit('change', choose)
    }
  },
  watch: {
    contents: function (val) {
      this.condition = val.content
      this.day = val.day
      this.hours = val.hours
      this.nodeType = val.nodeType
      this.mins = val.mins
      console.log('contents1', val)
    }
  },
  created() {
    this.getActivityList()
    this.loadGroupList()
    console.log('contents2', this.contents)
  }
}
</script>

<style scoped>

</style>
